// FETCH ALL WASHING INWARD
export const FETCH_WASHING_INWARD_MASTER_REQUEST_DK = 'FETCH_WASHING_INWARD_MASTER_REQUEST_DK';
export const FETCH_WASHING_INWARD_MASTER_SUCCESS_DK = 'FETCH_WASHING_INWARD_MASTER_SUCCESS_DK';
export const FETCH_WASHING_INWARD_MASTER_FAILURE_DK = 'FETCH_WASHING_INWARD_MASTER_FAILURE_DK';

// CREATE WASHING INWARD
export const CREATE_WASHING_INWARD_MASTER_REQUEST_DK = 'CREATE_WASHING_INWARD_MASTER_REQUEST_DK';
export const CREATE_WASHING_INWARD_MASTER_SUCCESS_DK = 'CREATE_WASHING_INWARD_MASTER_SUCCESS_DK';
export const CREATE_WASHING_INWARD_MASTER_FAILURE_DK = 'CREATE_WASHING_INWARD_MASTER_FAILURE_DK';

// UPDATE WASHING INWARD
export const UPDATE_WASHING_INWARD_MASTER_REQUEST_DK = 'UPDATE_WASHING_INWARD_MASTER_REQUEST_DK';
export const UPDATE_WASHING_INWARD_MASTER_SUCCESS_DK = 'UPDATE_WASHING_INWARD_MASTER_SUCCESS_DK';
export const UPDATE_WASHING_INWARD_MASTER_FAILURE_DK = 'UPDATE_WASHING_INWARD_MASTER_FAILURE_DK';

// FETCH SINGLE STATE OF WASHING INWARD
export const FETCH_SINGLE_WASHING_INWARD_MASTER_REQUEST_DK = 'FETCH_SINGLE_WASHING_INWARD_MASTER_REQUEST_DK';
export const FETCH_SINGLE_WASHING_INWARD_MASTER_SUCCESS_DK = 'FETCH_SINGLE_WASHING_INWARD_MASTER_SUCCESS_DK';
export const FETCH_SINGLE_WASHING_INWARD_MASTER_FAILURE_DK = 'FETCH_SINGLE_WASHING_INWARD_MASTER_FAILURE_DK';

// DELETE WASHING INWARD
export const DELETE_WASHING_INWARD_MASTER_REQUEST_DK = 'DELETE_WASHING_INWARD_MASTER_REQUEST_DK';
export const DELETE_WASHING_INWARD_MASTER_SUCCESS_DK = 'DELETE_WASHING_INWARD_MASTER_SUCCESS_DK';
export const DELETE_WASHING_INWARD_MASTER_FAILURE_DK = 'DELETE_WASHING_INWARD_MASTER_FAILURE_DK';

export const FETCH_PENDING_WASHING_PO_IN_INWARD_REQUEST_DK = 'FETCH_PENDING_WASHING_PO_IN_INWARD_REQUEST_DK';
export const FETCH_PENDING_WASHING_PO_IN_INWARD_SUCCESS_DK = 'FETCH_PENDING_WASHING_PO_IN_INWARD_SUCCESS_DK';
export const FETCH_PENDING_WASHING_PO_IN_INWARD_FAILURE_DK = 'FETCH_PENDING_WASHING_PO_IN_INWARD_FAILURE_DK';

export const RESET_WASHING_INWARD_MASTER_INFO_DK = 'RESET_WASHING_INWARD_MASTER_INFO_DK';

export const CREATE_WASHING_INWARD_MASTER_FORM_DK = 'CREATE_WASHING_INWARD_MASTER_FORM_DK';

export const UPDATE_WASHING_INWARD_MASTER_FORM_DK = 'UPDATE_WASHING_INWARD_MASTER_FORM_DK';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_WASHING_INWARD_DETAILS_DK = 'NAVIGATE_WASHING_INWARD_DETAILS_DK';

// NAVIGATE TO WASHING INWARD COMPONENT
export const NAVIGATE_WASHING_INWARD_MASTER_DK = 'NAVIGATE_WASHING_INWARD_MASTER_DK';

export const RESET_FORM_DATA_WITHOUT_WASHING_INWARD_ID_DK = 'RESET_FORM_DATA_WITHOUT_WASHING_INWARD_ID_DK';

export const SET_ACTIVE_KEY_WASHING_INWARD_DK = 'SET_ACTIVE_KEY_WASHING_INWARD_DK';
